import { t } from 'i18next';
import styles from './PrivateTransportCard.module.css';
import Money from '../Common/Money/Money';
import Button from '../Common/Button/Button';

const PrivateTransportCard = ({ product, onReserve }) => {
  return (
    <div
      className={`${styles.card} ${
        product.images && product.images.length > 0 ? styles.cardImage : ''
      }`}
    >
      {product.images && product.images.length > 0 && (
        <div className={styles.imageWrapper}>
          <img src={product.images} alt={t('privateTransport.altImage')} className={styles.image} />
        </div>
      )}

      <div className='font-normal fw-600 text-center'>{product.name}</div>

      <div
        className={styles.features + ' font-small text-tertiary mt-2'}
        dangerouslySetInnerHTML={{
          __html: product.description,
        }}
      ></div>
      <div className={styles.footer}>
        <div className='text-center'>
          <div className='font-tiny text-tertiary'>{t('priceFrom')}</div>
          <div className={styles.amount}>
            <Money value={product.prices.price} decimal={false} />
          </div>
        </div>
        <Button
          text={t('select')}
          onClick={(e) => {
            e.stopPropagation();
            onReserve();
          }}
          size='normal'
          className={'w-100 mt-2'}
        />
      </div>
    </div>
  );
};

export default PrivateTransportCard;
